import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// Thunks
export const fetchInvoices = createAsyncThunk(
  'invoice/fetchInvoices',
  async (companyId) => {
    const res = await fetch(
      `/api/invoices/filter/search?companyId=${companyId}`
    )
    return await res.json()
  }
)

export const createInvoice = createAsyncThunk(
  'invoice/createInvoice',
  async (invoiceData) => {
    const res = await fetch('/api/invoices', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(invoiceData),
    })
    return await res.json()
  }
)

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState: {
    invoices: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.loading = false
        state.invoices = action.payload
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
      .addCase(createInvoice.fulfilled, (state, action) => {
        state.invoices.push(action.payload)
      })
  },
})

export default invoiceSlice.reducer
